export default {
    map:{
        InfoBase:"Basic Info",
        Sensor:"Sensor",
        Gateway:"Gateway",
        Display:"Display",
        Relay:"Relay",
        back:"Back",
        refresh:"Refresh",
        loadMapDataFailed:"Failed to load map data",
        loadTrackFailed:"Failed to load track",
        getDeviceDetailFailed:"Failed to get device details",
        getDetailFailed:"Failed to get details",
        details:"Details",
        headquarters:"Headquarters",
        latitude:"Latitude",
        longitude:"Longitude",
        moving:"Moving",
        viewFloorPlan:"View Floor Plan",
        monitoringOverview:"Monitoring Overview",
        floorPlan:"Floor Plan",
        deviceView:"Device View",
        assetView:"Asset View",
        floorPlanHint:"Hover over device markers to view details, click devices to jump to history curves, double-click images for fullscreen (click anywhere to close)",
        temperatureSensor:"Temperature & Humidity Sensor",
        gasSensor:"Gas Sensor",
        doorMagnetic:"Door Magnetic",
        airSensor:"Air Quality Sensor",
        unknownDevice:"Unknown Device",
        vehicleTrace:"Vehicle Trace",
        warning:"Warning",
        offline:"Offline",
        stopped:"Stopped",
        currentTemperature:"Current Temperature",
        averageSpeed:"Average Speed",
        maxTemperature:"Max Temperature",
        minTemperature:"Min Temperature",
        tracePoints:"Trace Points",
        drivingTimeline:"Driving Timeline",
        temperatureTrend:"Temperature Trend",
        onlineDevices:"Online Devices",
        warningDevices:"Abnormal Devices",
        dangerDevices:"Offline Devices",
        vehicles:"Dynamic Assets",
        recentEvents:"Recent Events",
        noAlerts:"No Alerts",
        view_track:"View Track",
        track_dialog_title:"Track",
        track_total_points:"Total Points",
        track_avg_speed:"Avg Speed",
        track_max_speed:"Max Speed",
        track_speed_color:"Speed Color",
        track_sensor_data:"Sensor Data",
        track_collection_time:"Collection Time",
        track_speed:"Speed",
        temperature:"Temperature",
        humidity:"Humidity",
        track_rendering_control:"Track Rendering Control",
        point_size:"Point Size",
        line_width:"Line Width",
        speed_unit_mph:"km/h",
        speed_0_mph:"0 km/h",
        max:"Max"
    }
}
